import { render } from "./PatientRegistrationModal.vue?vue&type=template&id=0e7e06bc&scoped=true"
import script from "./PatientRegistrationModal.vue?vue&type=script&lang=js"
export * from "./PatientRegistrationModal.vue?vue&type=script&lang=js"

import "./PatientRegistrationModal.vue?vue&type=style&index=0&id=0e7e06bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7e06bc"]])

export default __exports__